import React, { useEffect, useState } from 'react';
//Hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//Comp
import ProfileInfo from './ProfileInfo';//프로필정보
import ProfileUpdate from './ProfileUpdate';//프로필수정
import BottomsheetPartnerInfoUpdate from '../../bottomsheet/PartnerInfoUpdate';//프로필수정-bottomsheet

export default function Profile() {
    const { timeListAPI//타임리스트API
        , windowSizes//화면사이즈useRef
        , windowResizeHandler//화면사이즈핸들러
    } = useComnHook();

    useEffect(() => {
        windowResizeHandler();//화면사이즈핸들러
        timeListAPI();//타임리스트API
	} ,[]);

    /* =============== 회원정보수정 팝업오픈 =============== */
    const [ isOpen,setOpen ] = useState(false);
    const onDismissHandler = (value) => {
        setOpen(value);
    }
    /* =============== 회원정보수정 팝업오픈 =============== */

    return (
        <>
        {!isOpen ? 
            <ProfileInfo onDismiss={onDismissHandler} />
        : windowSizes.current.width > 767 ?  
            <ProfileUpdate isOpen={isOpen} onDismiss={onDismissHandler} />
        : windowSizes.current.width <= 767 ?
            <BottomsheetPartnerInfoUpdate isOpen={isOpen} onDismiss={onDismissHandler} />
        : null}
        </>
    );
}